import { render, staticRenderFns } from "./ServiceDashboardSummaryCard.vue?vue&type=template&id=9a57a0ea&"
var script = {}
import style0 from "./ServiceDashboardSummaryCard.vue?vue&type=style&index=0&id=9a57a0ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports